import { themeObject } from 'lib';

export type SORT = null | 'asc' | 'desc';

export interface ListItemType {
    id: string | number;
    name?: string;
    item: string | React.JSX.Element;
}

export const sortableSearchListItemTableStyles = {
    listContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        overflow: 'auto',
        pt: 1,
        pb: 0.5,
        px: 0.5,
    },
    resultsContainer: {
        mt: 2,
        mb: 1,
        display: 'flex',
        flexDirection: 'row',
    },
    resultsText: {
        ...themeObject.typography.default,
        ...themeObject.typography.body1,
        color: themeObject.palette.primary[700],
        fontWeight: 400,
    },
    boldResultsText: {
        ...themeObject.typography.default,
        ...themeObject.typography.body1,
        color: themeObject.palette.primary[700],
        fontWeight: 700,
    },
};
